module.exports = __webpack_public_path__ + "static/media/screening.b5784960.svg";